<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Codigo de verificación
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-form @submit.prevent="sendVerification()">
                      <div class="position-relative">
                        <v-text-field
                          v-model="code"
                          v-validate="'required'"
                          data-vv-name="code"
                          data-vv-as="codigo"
                          :error-messages="errors.collect('code')"
                          label="Codigo"
                          color="black"
                          type="code"
                          @focus="message = ''">
                        </v-text-field>
                        <div class="timer position-absolute" v-if="timerCount > 0 && !loading">
                          {{ time }}
                        </div>
                        <small v-if="message" class="text-danger mb-3">{{ message }}</small>
                      </div>
                      <v-btn class="k-orange-linear white--text" type="submit" :disabled="loadingForm"  block large>ENVIAR</v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')"  width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';
import Sidebar from '@/components/login/Sidebar';
import LogRocket from 'logrocket';

export default {
  beforeRouteEnter(to, from, next) {
    const cred = store.getters['user/credentials'];
    if (!cred.email || !cred.password) {
      localStorage.clear();
      next({
        name: 'Login',
      });
    } else {
      next();
    }
  },
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  data() {
    return {
      code: '',
      loading: false,
      expiration: '',
      timerCount: 0,
      message: '',
      loadingForm: false,
    };
  },
  computed: {
    icon() {
      if (this.loading) {
        return 'fas fa-sync-alt fa-spin';
      }
      return this.timerCount > 0 ? null : 'refresh';
    },
    time() {
      let minutes = Math.floor(this.timerCount / 60);
      let seconds = timerCount % 60;

      return `${minutes}:${seconds}`;
    },
  },
  methods: {
    sendVerification() {
      this.message = '';
      if (!this.code) {
        this.message = 'El codigo es obligatorio';
      } else {
        this.loadingForm = true;
        const credentials = this.$store.getters['user/credentials'];
        this.$auth.login({
          data: {
            email: credentials.email,
            password: credentials.password,
            code: this.code,
          },
          async success({ data }) {
            this.loadingForm = false;
            if (data.AUTH_STEP !== 'AUTH_ERROR') {
              this.$store.commit('user/CLEAR_AUTH_CREDENTIAL');
              window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${data.token}`;
              localStorage.setItem('verified', true);
              if (process.env.NODE_ENV === 'production') {
                LogRocket.identify(this.$auth.user().id, {
                  name: `${this.$auth.user().first_name} ${this.$auth.user().last_name}`,
                  email: this.$auth.user().email,
                });
              }
              this.$router.push({ name: 'home' });
            } else {
              Object.keys(data.errors).forEach((item) => {
                this.errors.add({
                  field: 'code',
                  msg: data.errors[item][0],
                });
              });
            }
          },
        }).catch((error) => {
          this.loadingForm = false;
          console.log(error.response);
          if (error.response) {
            const data = error.response.data;
            let message = '';
            switch (data.code) {
              case 'invalid':
                message = 'El codigo es invalido, se ha enviado un codigo nuevo a su correo';
                break;
              case 'expired':
                message = 'El codigo ha expirado, se ha enviado un codigo nuevo a su correo';
                break;
              default: 
                message = 'El codigo es incorrecto, se ha enviado un codigo nuevo a su correo';
                break;
            }
            this.errors.add({
              field: 'code',
              msg: message,
            });
          }
        });
      }
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .timer {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
  .text-danger {
    color: rgb(255, 82, 82);
  }
</style>


// WEBPACK FOOTER //
// src/components/login/VerificationCode.vue